import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// トスアップフォーム - チャットアプリ連携一覧取得
export async function getTossUpFormChatApps(id: string) {
  try {
    const path = "tossUpFormChatApps";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
// トスアップフォーム - チャットアプリ連携詳細取得
export async function getTossUpFormChatApp(id: string) {
  try {
    const path = "tossUpFormChatApp";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.detail_data && response.data.detail_data.length > 0) {
      return response.data.detail_data[0];
    }
    return null;
  } catch (error) {
    return null;
  }
}
// トスアップフォーム - チャットアプリ連携詳細編集
export async function putTossUpFormChatApp(editData: EditDataDifine) {
  try {
    const path = "tossUpFormChatApp";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// トスアップフォーム - チャットアプリ連携登録
export async function postTossUpFormChatApp(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "tossUpFormChatApp";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// トスアップフォーム - チャットアプリ連携削除
export async function deleteTossUpFormChatApp(id: string) {
  try {
    const path = "tossUpFormChatApp";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}
